import React from 'react';
import {connect, useSelector} from 'react-redux';
import Reaptcha from 'reaptcha';
import FormGroup from './form/FormGroup';
import TurnstileCaptchaRenderer from "./TurnstileCaptchaRenderer";


function RecaptchaRenderer(props){
    if(document.location.host.endsWith("goaffpro.com")){
        return <TurnstileCaptchaRenderer onChange={props.onChange}/>;
    }
    return <GoogleRecaptchaRenderer
        onChange={props.onChange}
        recaptcha_enabled={props.recaptcha_enabled}
        recaptcha_site_key={props.recaptcha_site_key}
    />;
}

function GoogleRecaptchaRenderer({onChange, recaptcha_enabled, recaptcha_site_key}){

    const onVerified = (response) => {
        if (onChange) {
            onChange({target: {
                value: {
                    type:'recaptcha',
                    value: response,
                }
            }});
        }
    }
    if (!recaptcha_enabled) return null;
    return (<FormGroup>
            <Reaptcha sitekey={recaptcha_site_key} onVerify={onVerified}/>
        </FormGroup>
    );
}

function mapStateToProps(state) {
    return {
        recaptcha_enabled: state.settings.recaptcha_enabled,
        recaptcha_site_key: state.settings.recaptcha_site_key || '6Lf_jsQUAAAAAOLW40PpDXgZQDIjjnGldAE1fhYr',
        locale: state.settings.locale,
    }
}

export default connect(mapStateToProps)(RecaptchaRenderer);
